import SelectImagePopup from "./SelectImagePopup";
import { jsx as _jsx } from "react/jsx-runtime";
export default function initializeSelectImage(selectImage, content) {
  var popupEvent = new CustomEvent("openPopup", {
    detail: {
      C: function C() {
        return /*#__PURE__*/_jsx(SelectImagePopup, {
          content: content,
          selectImage: selectImage
        });
      }
    }
  });
  window.dispatchEvent(popupEvent);
}